<template>
  <div class="pop toast" v-show="toastMsg"  for="pop" style="position: fixed; top: 50%; left: 50%; -webkit-transform: translate(-50%, -50%);transform: translate(-50%, -50%);; z-index: 99999;">
    <p class="fail" v-html="toastMsg"></p>
  </div>
</template>

<script>
export default {
  name: "Toast",
  props: ["toastMsg"]
}
</script>

<style scoped>
.pop {
  display: block;
  position: relative;
  /*min-width: 5rem;*/
  /*margin: 0 1rem;*/
}
.toast {
  background: rgba(0, 0, 0, 0.8);
  /*min-width: 4rem;*/
  /*width: 3rem;*/
  padding: 0 0.5rem;
  /*height: 0.6rem;*/
  border-radius: 0.1rem;
  text-align: center;
  line-height: 0.6rem;
}
.toast .fail {
  color: white;
  font-size: 0.2rem;
  /*height: 0.6rem;*/
}
</style>
